// @Version: 1.0.0
import { Injectable } from '@angular/core';
import { Subscription, timer } from 'rxjs';

export interface IShowSpinner {
   [key:number]: boolean; 
}

@Injectable({
   providedIn: 'root'
})
export class SpinnerService {

   private timer_?: Subscription;
   private spinnerList_: IShowSpinner = {0: false};
   private showSpinner_: boolean = false; 

   get enabled (): boolean {
      return this.showSpinner_; 
   }

   constructor () { }

   public start (start: number, index: number = 0): void {
      if (!this.showSpinner_) this.timer_ = timer(start).subscribe(() =>this.showSpinner_ = true);
      Object.assign(this.spinnerList_, {[index]: true});
   }

   public close (index: number = 0): void {
      Object.assign(this.spinnerList_, {[index]: false});

      if (this.timer_ && Object.keys(this.spinnerList_).findIndex(item => this.spinnerList_[+item]) == -1) {
         this.timer_.unsubscribe();
         this.showSpinner_ = false; 
      }
   }
}